<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UU5Gfe/media/FC-9781638294825.jpg?1685790453781" alt="This image is the cover for the book The Islands Are Not Lonely"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Islands Are Not Lonely
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"Grotesque Light",sans-serif;'>Many people are living lonely. But as the islands under the rocking sea are connected, we who suffer are also connected to each other if we look into each other more deeply. This poetry is the fruit of an effort to make you feel connected.</span></strong></p><p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;'><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yonah Jeong
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:16px;font-family:"Calibri",sans-serif;'>The author has a dream. The dream is love, not greed. So he has written poems for over 50 years. He cherishes himself, his people, his society. They are the foundation of his poetry.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22de0bce